
import "./App.css";

import sv from "../src/assets/sv (1).png";
import read from "../src/assets/reading.png";
import home from "../src/assets/pngwinga.png";
import jw from "../src/assets/joweli.png";
import React from "react";

function App() {



  return (
    <div>
      <div style={{position:"absolute", top:0, bottom:0, left:0, right:0,overflowX:"hidden" }}>
     <header id={'head'}>
          <nav>
            <div className="logo" >
            {/*  <a href="index.html"><img
                  src="https://res.cloudinary.com/abdel-rahman-ali/image/upload/v1535988515/logo-rosa-white.png"
                  alt="Rosa Logo"/></a>*/}
            </div>
            {/*<div className="toggle">
              <span className="first"></span>
              <span className="middle"></span>
              <span className="last"></span>
            </div>*/}
            <div className="navigation-bar">
              <ul>
                <li className="active"><a href="#">Home<span className="underline"></span></a></li>
                <li><a href="/signup">Signup<span className="underline"></span></a></li>
                <li><a href="/login">Login<span className="underline"></span></a></li>
              </ul>
            </div>
          </nav>
          <div className="text">
            <h2>Welcome</h2>
            <h1 >UDOM FIRM</h1>
            <div className="arrow">
              <span className="left"></span>
              <i className="fas fa-asterisk"></i>
              <span className="right"></span>
            </div>
            <span>Ready To Be Opened</span>
            <div className="button">
              <a className={'a'} href={'/login'}><button>Get Started</button></a>
            </div>
          </div>


      <img className="svg-down"  style={{width:'192px', height:'62px'}}  src={sv}/>
          <a href={'#story'}><div className="arrow-down"></div></a>

        </header>


        <div id={'story'} className="about-us">
          <div className="text">
            <h2>Discover</h2>
            <h3>Our Story</h3>
            <div><i className="fas fa-asterisk"></i></div>
            <p>We’ve built a web based application spanned with Artificial Intelligence which interacts
              in a conversational way, where you can ask any academic questions and get quick response also via this
            site you can chat with other people across the globe, The aim if this site is to simplify tasks among
            universities students.</p>
              <center><a className={'a'} href={'/login'}><button className={'btn'} style={{minWidth:'10%', textTransform:"initial"}}>Try it</button></a></center>
           {/* <div><a className="a-CTA" href="#">About Us</a></div>*/}
          </div>
          <div className="image-container">
            <div className="image image1">
              <img src={read}
                   alt="Food Photo"/>
            </div>
          {/*  <div className="image image2">
              <img src="https://res.cloudinary.com/abdel-rahman-ali/image/upload/v1535988532/vertical-photo-2.jpg"
                   alt="Food Photo"/>
            </div>*/}
          </div>
        </div>


        <div className="menu">
          <div className="box-model">
            <i className="fas fa-times fa-2x close"></i>
            <div className="arrow">
              <div className="arrow arrow-right"></div>
              <div className="arrow arrow-left"></div>
            </div>
            <div className="box-image-container">
              <div className="box-image">
                <img src="" alt="Food Photo"/>
              </div>
            </div>
          </div>


          <div className="menu-image-container">

            <div className="image">
              <img src={home} style={{marginLeft:'10px'}} width={'400px'}
                   alt="Food Photo"/>
            </div>
          </div>


          <div className="text">
            <h2>Discover</h2>
            <h3>Activities</h3>
            <div><i className="fas fa-asterisk"></i></div>
            <p>We’ve built a web based application spanned with Artificial Intelligence which interacts in
                a conversational way, where you can ask any academic questions and get quick response also via this
                site you can chat with other people across the globe, The aim if this site is to simplify tasks among
                universities students.</p>
          </div>
        </div>


        <div className="fixed-image">
          <div className="text">
            <h2>The Perfect</h2>
            <h3>Blend</h3>
          </div>
        </div>


          <footer>
              <div className="text">
                  <h2>ABOUT UDOM FIRM.</h2>
                  <div><i className="fas fa-asterisk"></i></div>
                  <p>We’ve built a web based application spanned with Artificial Intelligence which interacts in a
                      conversational way, where you can ask any academic questions and get quick response also via
                      this site you can chat with other people across the globe, The aim if this site is to simplify
                      tasks among universities students.</p>
              </div>
              <div className="contact-container">
                  <div className="social-media">
                      <h3>Follow Along</h3>
                      <div className="links">
                          <a href="#"><i className="fab fa-twitter"></i></a>
                          <a href="#"><i className="fab fa-facebook-square"></i></a>
                          <a href="#"><i className="fab fa-pinterest"></i></a>
                          <a href="#"><i className="fab fa-linkedin-in"></i></a>
                      </div>
                  </div>
                  <div className="newsletter">
                      <h3>NewsLetter</h3>
                      <form method="post">
                          <input type="email" name="email" placeholder="Type Your Email"/>
                              <i className="fas fa-envelope"></i>
                      </form>
                  </div>
              </div>
          </footer>

          <div className="copyright">
                       <svg
   className="svg-up"
   width="162.30678"
   height="61"
   version="1.1"
   x="0px"
   y="0px"
   viewBox="0 0 135.84739 61.5"
   enable-background="new 0 0 160.7 61.5"
   id="svg4"
   xmlns="http://www.w3.org/2000/svg"
   ><defs
     id="defs8" /><path
     fill="#262526"
     d="m 66.886816,61.5 c 0,0 22.1,-2.7 43.100004,-5.4 21,-2.7 41,-5.4 36.6,-5.4 -21.7,0 -34.1,-12.7 -44.9,-25.4 C 90.886816,12.6 81.886816,0 66.886816,0 c -15,0 -24.1,12.7 -34.9,25.4 -10.8,12.7 -23.1000002,25.4 -44.8,25.4 -4.3,0 -6.5,0 3.4999998,1.3 10.00000002,1.3 32.1000002,4 76.2000002,9.4 z"
     id="path2" /></svg>

              <a href={'#head'}><i className="fas fa-angle-double-up arrow-up"></i></a>
              <ul className="info">
                  <li>&copy; jowzey 2023</li>
                  <li>13 Udom, Dodoma</li>
                  <li>Phone: +255 769465102</li>
                  <li>Powered by by <a href="#">Zacharia Mwalwama</a> Team</li>
              </ul>
              <ul className="CTA">
                  <li><a href="#">THANK YOU!!! THANK YOU!!!</a></li>
                  <li><a href="#">WELCOME.</a></li>
              </ul>
          </div>


</div>
    </div>
  );
}

export default App;
